module.exports = __webpack_public_path__ + "img/login-1.44bdf3bc.png";